// src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import "./index.css";

// -------- Pages (your existing components) --------
import Index from "./superAdmin/login";
import Tenant from "./superAdmin/tenant";
import TenantEdit from "./superAdmin/tenantEdit";
import Tenant_Add from "./superAdmin/tenant_Add";
import Tenant_Bootstrap from "./superAdmin/tenant_Bootstrap";
import Admin_menu from "./superAdmin/admin_Menu";
import Admin_Menu_edit from "./superAdmin/admin_Menu_edit";
import Admin_module from "./superAdmin/admin_module";
import SuperAdminUsers_List from "./superAdmin/superAdminUsers_List";
import SuperAdminUsers_Add from "./superAdmin/superAdminUsers_Add";
import SuperAdminUsers_Edit from "./superAdmin/superAdminUsers_Edit";
import MiniDatabase from "./superAdmin/mini_database";


// -------- Simple, robust route guard --------
function safeParse(json) { try { return JSON.parse(json); } catch { return null; } }

function RequireSuperAdmin() {
  const session = safeParse(localStorage.getItem("patrol_superadmin"));
  const loc = useLocation();
  // No session? Always bounce to login.
  if (!session) return <Navigate to="/superAdmin/login" replace state={{ from: loc }} />;
  return <Outlet />;
}

export default function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          {/* ---------- Public routes (login) ---------- */}
          <Route path="/" element={<Index />} />
          <Route path="/superAdmin/login" element={<Index />} />
          {/* Optional lowercase alias if needed */}
          <Route path="/superadmin/login" element={<Index />} />

          {/* ---------- Protected routes (require session) ---------- */}
          <Route element={<RequireSuperAdmin />}>
            <Route path="/superAdmin/tenant" element={<Tenant />} />
            <Route path="/superAdmin/tenantEdit/:tenantId" element={<TenantEdit />} />
            <Route path="/superAdmin/tenant_Add" element={<Tenant_Add />} />
            <Route path="/superAdmin/tenant_Bootstrap" element={<Tenant_Bootstrap />} />

            <Route path="/superAdmin/admin_Menu" element={<Admin_menu />} />
            <Route path="/superAdmin/admin_Menu_edit/:username" element={<Admin_Menu_edit />} />
            <Route path="/superAdmin/admin_module/:username" element={<Admin_module />} />
            <Route path="/superAdmin/mini_database" element={<MiniDatabase />} />
            

            <Route path="/superAdmin/superAdminUsers_List" element={<SuperAdminUsers_List />} />
            <Route path="/superAdmin/superAdminUsers_Add" element={<SuperAdminUsers_Add />} />
            <Route path="/superAdmin/superAdminUsers_Edit/:id" element={<SuperAdminUsers_Edit />} />
          </Route>

          {/* ---------- Catch-all: redirect unknown routes to login ---------- */}
          <Route path="*" element={<Navigate to="/superAdmin/login" replace />} />
        </Routes>
      </Router>
    </div>
  );
}
